import React, { useState, useEffect, useMemo } from "react";
import "../../../css/CRUDModal.css";
import ButtonTriangle from "../../../assets/Icons/Button Triangle.png";
import FilterIcon from "../../../assets/Icons/Orange Filter.png";
import CrossIcon from "../../../assets/Icons/cross_svg.svg";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";
import Dropdown from "../../../components/Dropdown";
import { useForm, Controller } from "react-hook-form";
import { Box } from "@mui/material";

const statusOptions = [
  { label: "ACTIVE", value: "ACTIVE" },
  { label: "INACTIVE", value: "INACTIVE" },
];

const RateCardFilterModal = ({
  show,
  handleClose,
  filterData,
  setFilterData,
  handleReset,
  applyFilters,
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: {
      rateCardId: filterData?.rateCardId || "",
      rateCardName: filterData?.rateCardName || "",
      status: filterData?.status || "",
    },
    mode: "onChange",
  });

  const watchedValues = watch();

  useEffect(() => {
    if (show) {
      reset({
        rateCardId: filterData?.rateCardId || "",
        rateCardName: filterData?.rateCardName || "",
        status: filterData?.status || "",
      });
    }
  }, [show, filterData, reset]);

  const [selectedTab, setSelectedTab] = useState("Rate Card Id");

  const currentStatus =
    watchedValues?.status || filterData?.status || "";

  const statusDropdownOptions = useMemo(() => {
    if (currentStatus) {
      return [
        { label: "✕ Clear Status Selection", value: "" },
        ...statusOptions,
      ];
    }
    return statusOptions;
  }, [currentStatus]);

  const hasActiveFilter = (tabName) => {
    switch (tabName) {
      case "Rate Card Id":
        return Boolean(
          filterData?.rateCardId && filterData.rateCardId.trim() !== ""
        );
      case "Rate Card Name":
        return Boolean(
          filterData?.rateCardName && filterData.rateCardName.trim() !== ""
        );
      case "Status":
        return Boolean(filterData?.status && filterData.status.trim() !== "");
      default:
        return false;
    }
  };

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const onSubmit = (formData) => {
    setFilterData(formData);
    if (applyFilters) {
      applyFilters(formData);
    }
    handleClose();
  };

  const onReset = () => {
    const emptyFilters = {
      rateCardId: "",
      rateCardName: "",
      status: "",
    };
    reset(emptyFilters);
    setFilterData(emptyFilters);
    handleReset();
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <div className="flex items-center gap-2">
                  <img src={FilterIcon} alt="filter icon" className="w-6 h-6" />
                  <h5 className="modal-title main-title">Filter</h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="close icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleClose}
                />
              </div>
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {["Rate Card Id", "Rate Card Name", "Status"].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                            style={
                              hasActiveFilter(tab) && selectedTab !== tab
                                ? {
                                    outline: "2px solid #FF6B35",
                                    outlineOffset: "2px",
                                  }
                                : {}
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content !bg-[linear-gradient(to_bottom,#FFE8D4_0%_100%,transparent_25%_100%)]">
                      {/* Rate Card Id Tab */}
                      {selectedTab === "Rate Card Id" && (
                        <Controller
                          name="rateCardId"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">Rate Card Id</label>
                              <div className="dateInputWrapper">
                                <input
                                  {...field}
                                  type="text"
                                  placeholder="Enter Rate Card Id"
                                  className="dateInput"
                                  value={
                                    field.value !== undefined
                                      ? field.value
                                      : watchedValues?.rateCardId ||
                                        filterData?.rateCardId ||
                                        ""
                                  }
                                  onChange={(e) => {
                                    field.onChange(e.target.value);
                                    setValue("rateCardId", e.target.value);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      rateCardId: e.target.value,
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        />
                      )}

                      {/* Rate Card Name Tab */}
                      {selectedTab === "Rate Card Name" && (
                        <Controller
                          name="rateCardName"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">Rate Card Name</label>
                              <div className="dateInputWrapper">
                                <input
                                  {...field}
                                  type="text"
                                  placeholder="Enter Rate Card Name"
                                  className="dateInput"
                                  value={
                                    field.value !== undefined
                                      ? field.value
                                      : watchedValues?.rateCardName ||
                                        filterData?.rateCardName ||
                                        ""
                                  }
                                  onChange={(e) => {
                                    field.onChange(e.target.value);
                                    setValue("rateCardName", e.target.value);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      rateCardName: e.target.value,
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        />
                      )}

                      {/* Status Tab */}
                      {selectedTab === "Status" && (
                        <Controller
                          name="status"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">Status</label>
                              <div className="dateInputWrapper">
                                <Dropdown
                                  placeholder="Select Status"
                                  options={statusDropdownOptions}
                                  value={
                                    field.value ||
                                    watchedValues?.status ||
                                    filterData?.status ||
                                    ""
                                  }
                                  labelKey="label"
                                  valueKey="value"
                                  showSearch={false}
                                  selectClassName="!h-[38px] !rounded-[6px]"
                                  onChange={(item) => {
                                    const selectedStatus =
                                      item && item.value ? item.value : "";
                                    field.onChange(selectedStatus);
                                    setValue("status", selectedStatus);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      status: selectedStatus,
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back w-[133px] !rounded-lg"
                      onClick={onReset}
                    >
                      Reset
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="submit"
                      className="btn btn-submit w-[133px] !rounded-lg"
                      disabled={isSubmitting}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RateCardFilterModal;
